module.exports = __webpack_public_path__ + "static/media/email.b1170261.png";